import { ArticleEntity } from 'src/modules/articles';
import { ReferenceEntity } from 'src/modules/professionals';

export enum ProfessionalsReferencesDetailsActions {
  FetchDetailsBegin = 'PROFESSIONALS/REFERENCES/DETAILS/FETCH/BEGIN',
  FetchDetailsSuccess = 'PROFESSIONALS/REFERENCES/DETAILS/FETCH/SUCCESS',
  FetchDetailsError = 'PROFESSIONALS/REFERENCES/DETAILS/FETCH/ERROR',
  FetchRelatedReferencesDetailsBegin = 'PROFESSIONALS/REFERENCES/RELATED_REFERENCES_DETAILS/FETCH/BEGIN',
  FetchRelatedReferencesDetailsSuccess = 'PROFESSIONALS/REFERENCES/RELATED_REFERENCES_DETAILS/FETCH/SUCCESS',
  FetchRelatedReferencesDetailsError = 'PROFESSIONALS/REFERENCES/RELATED_REFERENCES_DETAILS/FETCH/ERROR',
}

export interface ProfessionalsReferencesDetailsStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  isLoadingRelatedReferences: boolean;
  isLoadedRelatedReferences: boolean;
  errorRelatedReferences: any;
  article: ArticleEntity;
  relatedReferences: ReferenceEntity[];
}
